import React from 'react';
import { Edit, Trash2, Ban, Check, Loader2 } from 'lucide-react';

// One look for every row action in the admin screens: an icon + label pill, tinted by meaning.
// Same meaning = same color everywhere (edit indigo, activate green, deactivate amber, delete red, info blue).
const BASE_CLASSES =
  'inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const ACTION_VARIANTS = {
  edit: { classes: 'text-indigo-600 bg-indigo-50 hover:bg-indigo-100', Icon: Edit, label: 'Edit' },
  activate: { classes: 'text-green-600 bg-green-50 hover:bg-green-100', Icon: Check, label: 'Activate' },
  deactivate: { classes: 'text-amber-700 bg-amber-50 hover:bg-amber-100', Icon: Ban, label: 'Deactivate' },
  delete: { classes: 'text-red-600 bg-red-50 hover:bg-red-100', Icon: Trash2, label: 'Delete' },
  info: { classes: 'text-blue-600 bg-blue-50 hover:bg-blue-100', Icon: null, label: '' },
};

export const AdminActionButton = ({
  variant = 'info',
  icon,
  label,
  loading = false,
  loadingLabel,
  disabled = false,
  onClick,
  title,
}) => {
  const config = ACTION_VARIANTS[variant] || ACTION_VARIANTS.info;
  const Icon = icon || config.Icon;
  const text = label || config.label;
  const shownText = loading && loadingLabel ? loadingLabel : text;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      title={title}
      className={`${BASE_CLASSES} ${config.classes}`}
    >
      {loading ? (
        <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
      ) : (
        Icon && <Icon className="h-3.5 w-3.5 mr-1" />
      )}
      {shownText}
    </button>
  );
};

// Wrapper that lays action buttons out identically (replaces the mixed `space-x-2` / `mr-3` spacing).
export const AdminRowActions = ({ align = 'end', className = '', children }) => (
  <div
    className={`flex items-center flex-wrap gap-2 ${align === 'start' ? 'justify-start' : 'justify-end'} ${className}`.trim()}
  >
    {children}
  </div>
);
